import React from 'react';
import styled from '@emotion/styled';
import { space } from 'styled-system';

import { useLocalization } from 'common/providers/LocaleProvider';
import whereToFind from './where-to-find.png';

const Wrapper = styled.div`
  ${space};
`;
const wrapperStyles = {
  p: 'sp_16',
};

const Image = styled.img`
  ${space};
`;
const imageStyles = {
  width: '100%',
  mt: 'sp_16',
};

export const RauchNumberDrawer = () => {
  const { t } = useLocalization();

  return (
    <Wrapper {...wrapperStyles}>
      {t('h24_rauch_number_drawer_description')}
      <Image
        src={whereToFind.src}
        alt={t('h24_rauch_number_drawer_description')}
        {...imageStyles}
      />
    </Wrapper>
  );
};
